<template>
  <div>
    <b-card no-body class="mb-3">
      <h6 slot="header" class="mb-0">
        <font-awesome-icon icon="cog" />ข้อมูลเพิ่มเติม
      </h6>

      <table class="table mb-0">
        <tbody>
          <tr>
            <td>
              <strong>ประเภทกิจกรรม</strong>
            </td>
            <td>
              <b-form-radio
                v-for="(option, index) in ['ด้านวิชาการ', 'ด้านกีฬาและนันทนาการ', 'ด้านคุณธรรมและจริยธรรม', 'ด้านส่งเสริมศิลปวัฒนธรรม', 'ด้านบำเพ็ญประโยชน์และรักษาสิ่งแวดล้อม']"
                :key="index"
                v-model="value.types"
                :value="option"
                name="types"
              >
                {{ option }}
              </b-form-radio>
            </td>
          </tr>
          <tr>
            <td>
              <strong>อัตลักษณ์สถาบัน</strong>
              <p>อธิบายลักษณะกิจกรรมในโครงการที่ส่งเสริมอัตลักษณ์ของสถาบัน (กรอกเฉพาะอัตลักษณ์ที่เกี่ยวข้อง)</p>
            </td>
            <td>
              <strong>ซื่อสัตย์</strong>
              <b-textarea v-model.trim="value.characteristics[0]" class="mb-3" rows="3" />
              <strong>ใฝ่รู้</strong>
              <b-textarea v-model.trim="value.characteristics[1]" class="mb-3" rows="3" />
              <strong>สู้งาน</strong>
              <b-textarea v-model.trim="value.characteristics[2]" class="mb-3" rows="3" />
            </td>
          </tr>
          <tr>
            <td>
              <strong>ทักษะ</strong>
            </td>
            <td>
              <b-form-checkbox-group v-model="value.skills" stacked>
                <b-form-checkbox value="การทำงานร่วมกัน">การทำงานร่วมกัน</b-form-checkbox>
                <b-form-checkbox value="ภาวะผู้นำและความรับผิดชอบ">ภาวะผู้นำและความรับผิดชอบ</b-form-checkbox>
                <b-form-checkbox value="การใช้เทคโนโลยี">การใช้เทคโนโลยี</b-form-checkbox>
                <b-form-checkbox value="ทักษะการใช้ภาษาต่างชาติ">ทักษะการใช้ภาษาต่างชาติ</b-form-checkbox>
                <b-form-checkbox value="ความสามารถในการแก้ปัญหา">ความสามารถในการแก้ปัญหา</b-form-checkbox>
                <b-form-checkbox value="ความคิดสร้างสรรค์">ความคิดสร้างสรรค์</b-form-checkbox>
                <b-form-checkbox value="การประสานและสื่อสารระหว่างบุคคลและ/หรือองค์กร">การประสานและสื่อสารระหว่างบุคคลและ/หรือองค์กร</b-form-checkbox>
              </b-form-checkbox-group>
            </td>
          </tr>
          <tr>
            <td class="align-middle">
              <strong>ยินยอมให้ประชาสัมพันธ์</strong>
            </td>
            <td class="align-middle">
              <b-form-checkbox v-model="value.isPromotingAllowed" :value="true">
                ยินยอมให้นำข้อมูลไปประชาสัมพันธ์ทั้งก่อนและหลังการจัดกิจกรรม
              </b-form-checkbox>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>
    <b-card no-body>
      <h6 slot="header" class="mb-0">
        <font-awesome-icon icon="cog" />การสะสมชั่วโมงกิจกรรม
      </h6>
      <div class="bg-warning px-3 py-2">
        <small>
          หากโครงการนี้มีการการสะสมชั่วโมงกิจกรรม หรือสร้างกิจกรรมบนระบบ KMITL Events จำเป็นต้องระบุข้อมูลส่วนนี้ให้ครบถ้วนและถูกต้อง
          เนื่องจากระบบจะไม่อนุญาตให้แก้ไขรายละเอียดบางส่วนในภายหลังได้
        </small>
      </div>
      <table class="table mb-0">
        <tbody>
          <tr>
            <td>
              <strong>วันที่จัดกิจกรรม</strong>
              <p>
                ระบุ<u><strong>เฉพาะวันที่เปิดให้ผู้เข้าร่วมกิจกรรมสามารถเข้าร่วมได้</strong></u> โดยไม่รวมขั้นตอนสำหรับผู้จัดงาน เช่น การวางแผนเตรียมงาน<br>
                กรณีจัดกิจกรรมหนึ่งวัน ให้เลือกวันเริ่มต้นและวันสิ้นสุดเป็นวันเดียวกัน
              </p>
            </td>
            <td>
              <v-date-picker v-model="value.publicTimeframeRaw" :columns="2" :popover="{ visibility: 'click' }" color="orange" locale="th" mode="range" @input="calculatePublicDayCount" />
            </td>
          </tr>
          <tr>
            <td>
              <strong>การสะสมชั่วโมงกิจกรรม</strong>
              <p>ระบุจำนวนชั่วโมงที่ผู้เข้าร่วมจะได้รับ กรณีเป็นกิจกรรมหลายวัน ให้กรอกจำนวนชั่วโมงรวมตลอดทั้งกิจกรรม</p>
            </td>
            <td>
              <p>
                กิจกรรม <b-badge>{{ publicDayCount }}</b-badge> วัน สามารถสะสมชั่วโมงกิจกรรมได้สูงสุด <b-badge>{{ publicDayCount * 8 }}</b-badge> ชั่วโมง<br>
                หมายเหตุ: จำนวนชั่วโมงกิจกรรม สูงสุดไม่เกิน 8 ชั่วโมง/วัน (ทุกตำแหน่ง)
              </p>
              <b-input-group size="sm" prepend="ประธานโครงการ" append="ชม." class="mb-2 w-50">
                <b-form-input
                  v-model.number="value.eventHoursCount.h"
                  class="text-center"
                  type="number"
                  min="0"
                  :max="maxHours"
                />
              </b-input-group>
              <b-input-group size="sm" prepend="เจ้าหน้าที่" append="ชม." class="mb-2 w-50">
                <b-form-input
                  v-model.number="value.eventHoursCount.s"
                  class="text-center"
                  type="number"
                  min="0"
                  :max="maxHours"
                />
              </b-input-group>
              <b-input-group size="sm" prepend="ผู้เข้าร่วมโครงการ" append="ชม." class="mb-2 w-50">
                <b-form-input
                  v-model.number="value.eventHoursCount.p"
                  class="text-center"
                  type="number"
                  min="0"
                  :max="maxHours"
                />
              </b-input-group>
            </td>
          </tr>
          <tr>
            <td>
              <strong>เงื่อนไขการแสดงทรานสคริปกิจกรรม (สำหรับผู้เข้าร่วมกิจกรรม)</strong>
            </td>
            <td>
              <b-form-radio-group v-model="value.eventHoursPolicy" name="eventHoursPolicy" stacked>
                <b-form-radio value="per_check_in">
                  เข้าร่วมกิจกรรมบางส่วน
                  <small class="form-text m-0 text-muted">
                    แสดงในทรานสคริปกิจกรรมเมื่อมีการเช็คอินเข้าร่วมกิจกรรมอย่างน้อย 1 ช่วง<br>
                    เหมาะสำหรับกิจกรรมที่ผู้เข้าร่วมกิจกรรมสามารถ<u><strong>เลือกเข้าร่วมเพียงบางช่วงได้</strong></u> เช่น Job Fair<br>
                    จำนวนชั่วโมงกิจกรรมที่ผู้เข้าร่วมจะได้รับต่อการเข้าร่วม 1 ครั้ง คือ จำนวนชั่วโมงตลอดทั้งกิจกรรม หารด้วย จำนวนช่วงการตรวจบัตร
                  </small>
                </b-form-radio>
                <b-form-radio value="whole_event" class="mt-2">
                  เข้าร่วมกิจกรรมครบถ้วน
                  <small class="form-text m-0 text-muted">
                    แสดงในทรานสคริปกิจกรรมเมื่อมีการเช็คอินเข้าร่วมกิจกรรมครบทุกช่วง<br>
                    เหมาะสำหรับกิจกรรมที่ผู้เข้าร่วมกิจกรรม<u><strong>จำเป็นต้องเข้าร่วมทุกช่วง</strong></u> ตั้งแต่เริ่มจนจบ เช่น ค่ายต่างจังหวัด<br>
                    จำนวนชั่วโมงกิจกรรมที่ผู้เข้าร่วมจะได้รับหากเข้าร่วมครบทุกช่วง คือ จำนวนชั่วโมงตลอดทั้งกิจกรรม<br>
                    หากเข้าร่วมไม่ครบทุกช่วง จะไม่แสดงในทรานสคริปกิจกรรม
                  </small>
                </b-form-radio>
              </b-form-radio-group>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>
  </div>
</template>

<script>
import ProjectEditValidatorMixins from '@/mixins/projectEditValidatorMixins'
import moment from 'moment'

export default {
  mixins: [ ProjectEditValidatorMixins ],
  props: {
    value: { type: Object, required: true }
  },
  data () {
    return {
      publicDayCount: 0
    }
  },
  computed: {
    maxHours () {
      return this.publicDayCount * 8
    }
  },
  methods: {
    calculatePublicDayCount (selectedDateRange) {
      let start = moment(selectedDateRange.start)
      let end = moment(selectedDateRange.end)
      this.publicDayCount = moment.duration(end.diff(start, 'days')) + 1
    }
  },
  validations: {
    value: {
      //
    }
  }
}
</script>

<style scoped lang="scss">
td {

  &:first-child {
    background-color: #f2f2f2;
    width: 220px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
